import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../../../helpers/global_helper";
import BbfsPopup from "./BbfsPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import { formatPrice, formatPricewithdecimal } from "../../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { getUserBalance, setCommonConfig } from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";

const BbfsBet = (props) => {
  const dispatch = useDispatch();
  const { betType } = props;
  const [inputs, setInputs] = useState({
    tebak: "",
    beli4D: "",
    depan3D: "",
    belakang3D: "",
    belakang2D: "",
    depan2D: "",
    tengah2D: "",
  });
  const [inputValues, setInputValues] = useState({
    tebak: "",
    beli4D: "",
    depan3D: "",
    belakang3D: "",
    belakang2D: "",
    depan2D: "",
    tengah2D: "",
  });
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);

  const [guessData, setGuessData] = useState({
    asort4number: {},
    asort3number: {},
    asort2number: {},
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [checkedState, setCheckedState] = useState({});
  const [total, setTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [typebet, setTypebet] = useState("");
  const [showInfo, setShowInfo] = useState(true);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [optionsEnabled, setOptionsEnabled] = useState({
    "2D Belakang": false,
    "2D Depan": false,
    "2D Tengah": false,
    "3D Depan": false,
    "3D Belakang": false,
    "4D Belakang": false,
  });
  const game_sub_child_type = useSelector(
    (state) => state.GameSubType.game_sub_child_type
  );
  const [multipleValue, setMultipleValue] = useState('');
  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);
  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    setShowInfo(true);
    handleReset();
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);

  useEffect(() => {
    if (Object.keys(betDiscount).length <= 0) {
      setIsDisabled(true);
      setErrorMessage(props.t("referresh_page"));
      setShowErrorPopup(true);
      return;
    }
  }, [betDiscount]);

  useEffect(() => {
    const initialCheckedState = {
      beli4D: true,
      depan3D: true,
      belakang3D: true,
      depan2D: true,
      tengah2D: true,
      belakang2D: true,
    };
    setCheckedState(initialCheckedState);
  }, []);

  useEffect(() => {
    if (isDataFetched) {
      calculateTotal();
    }
  }, [guessData, checkedState, inputs]);

  const handleTebakOnchange = (e) => {
    const { name, value } = e.target;
    if (!/^[0-9]*$/.test(value)) {
      return;
    }
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  useEffect(() => {
    const guessLength = inputs.tebak.length;

    if (guessLength === 2) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
      });
    } else if (guessLength === 3) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": true,
        "3D Belakang": true,
        "4D Belakang": false,
      });
    } else if (guessLength >= 4 && guessLength <= 9) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": true,
        "3D Belakang": true,
        "4D Belakang": true,
      });
    } else {
      setOptionsEnabled({
        "2D Belakang": false,
        "2D Depan": false,
        "2D Tengah": false,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
      });
    }

    if (guessLength < 9) {
      const resetDisabledInputs = {};
      if (!optionsEnabled["4D Belakang"] || guessLength < 4) resetDisabledInputs.beli4D = "";
      if (!optionsEnabled["3D Depan"] || guessLength < 3) resetDisabledInputs.depan3D = "";
      if (!optionsEnabled["3D Belakang"] || guessLength < 3) resetDisabledInputs.belakang3D = "";
      if (!optionsEnabled["2D Belakang"] || guessLength < 2) resetDisabledInputs.belakang2D = "";
      if (!optionsEnabled["2D Depan"] || guessLength < 2) resetDisabledInputs.depan2D = "";
      if (!optionsEnabled["2D Tengah"] || guessLength < 2) resetDisabledInputs.tengah2D = "";
      setInputs((prevInputs) => ({ ...prevInputs, ...resetDisabledInputs }));
    }

  }, [inputs.tebak]);

  const handleTebakInputChange = useCallback((e) => {
    let { name, value } = e.target;
    if (value !== "") {
      if (value.length > 9 || value.length < 2 || !/^[0-9]*$/.test(value)) {
        setIsDisabled(true);
        setErrorMessage(props.t("guess_filled_24_digit"));
        setShowErrorPopup(true);
        setInputs((prevInputs) => ({ ...prevInputs, [name]: "" }));
        return;
      }
    }
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  }, []);

  const handleInputBlur = useCallback(
    (e) => {
      let { name, value } = e.target;
      
      value = value.replace(',', '.');

      let minValue = null;

      if (name === "beli4D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin4d / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin4dFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin4dPrize123 / 1000;
        }
      } else if (name === "belakang3D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin3dBelakang / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin3dBelakangFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin3dBelakangPrize123 / 1000;
        }
      } else if (name === "belakang2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dBelakang / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dBelakangFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dBelakangPrize123 / 1000;
        }
      } else if (name === "depan3D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin3dDepan / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin3dDepanFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin3dDepanPrize123 / 1000;
        }
      } else if (name === "depan2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dDepan / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dDepanFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dDepanPrize123 / 1000;
        }
      } else if (name === "tengah2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dTengah / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dTengahFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dTengahPrize123 / 1000;
        }
      }

      let regex = '';
      let regexMin = minValue * 1000;
      if (String(regexMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberBlurValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      e.target.value = value;
      handleInputChange(e);
    }, [])


  const handleInputChange = useCallback(
    (e) => {
      let { name, value } = e.target;
      value = value.replace(',', '.');
      const displayname = e.target.getAttribute("displayname");
      const intValue = value;

      let minValue = null;
      let maxValue = null;

      if (name === "beli4D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin4d / 1000;
          maxValue = betDiscount.showMax4d / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin4dFullbet / 1000;
          maxValue = betDiscount.showMax4dFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin4dPrize123 / 1000;
          maxValue = betDiscount.showMax4dPrize123 / 1000;
        }
      } else if (name === "belakang3D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin3dBelakang / 1000;
          maxValue = betDiscount.showMax3dBelakang / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin3dBelakangFullbet / 1000;
          maxValue = betDiscount.showMax3dBelakangFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin3dBelakangPrize123 / 1000;
          maxValue = betDiscount.showMax3dBelakangPrize123 / 1000;
        }
      } else if (name === "belakang2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dBelakang / 1000;
          maxValue = betDiscount.showMax2dBelakang / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dBelakangFullbet / 1000;
          maxValue = betDiscount.showMax2dBelakangFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dBelakangPrize123 / 1000;
          maxValue = betDiscount.showMax2dBelakangPrize123 / 1000;
        }
      } else if (name === "depan3D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin3dDepan / 1000;
          maxValue = betDiscount.showMax3dDepan / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin3dDepanFullbet / 1000;
          maxValue = betDiscount.showMax3dDepanFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin3dDepanPrize123 / 1000;
          maxValue = betDiscount.showMax3dDepanPrize123 / 1000;
        }
      } else if (name === "depan2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dDepan / 1000;
          maxValue = betDiscount.showMax2dDepan / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dDepanFullbet / 1000;
          maxValue = betDiscount.showMax2dDepanFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dDepanPrize123 / 1000;
          maxValue = betDiscount.showMax2dDepanPrize123 / 1000;
        }
      } else if (name === "tengah2D") {
        if (betType === "discount") {
          minValue = betDiscount.showMin2dTengah / 1000;
          maxValue = betDiscount.showMax2dTengah / 1000;
        } else if (betType === "fullbet") {
          minValue = betDiscount.showMin2dTengahFullbet / 1000;
          maxValue = betDiscount.showMax2dTengahFullbet / 1000;
        } else if (betType === "prize123") {
          minValue = betDiscount.showMin2dTengahPrize123 / 1000;
          maxValue = betDiscount.showMax2dTengahPrize123 / 1000;
        }
      }

      // if (intValue < minValue) {
      //   // setIsDisabled(true);
      //   setErrorMessage(`Minimal bet ${displayname} is ${minValue}`);
      //   setShowErrorPopup(true);
      //   return;
      // } else 
      if (intValue > maxValue) {
        // setIsDisabled(true);
        setErrorMessage(props.t("you_have_reached_max_bet_value"));
        setShowErrorPopup(true);
        return;
      }
      let regex = '';
      let regexMin = minValue * 1000;      
      if (String(regexMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (value === "" || (regex.test(value) && !isNaN(intValue))) {
        setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
      }
    },
    [betType, betDiscount]
  );

  const handleKeyDown = (e) => {
    if (e.key === 'Tab' && showErrorPopup) {
      e.preventDefault(); // Prevent the default tab behavior
    }
  };

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setInputs({
      tebak: "",
      beli4D: "",
      depan3D: "",
      belakang3D: "",
      belakang2D: "",
      depan2D: "",
      tengah2D: "",
    });
    setGuessData({
      asort4number: {},
      asort3number: {},
      asort2number: {},
    });
    setIsDisabled(false);
    setOptionsEnabled({
      "2D Belakang": false,
      "2D Depan": false,
      "2D Tengah": false,
      "3D Depan": false,
      "3D Belakang": false,
      "4D Belakang": false,
    });
    setIsDataFetched(false);
    setSubmitResult({});
    const initialCheckedState = {
      beli4D: true,
      depan3D: true,
      belakang3D: true,
      depan2D: true,
      tengah2D: true,
      belakang2D: true,
    };
    setCheckedState(initialCheckedState);
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const getGuessList = (data) => {
    setShowInfo(false);
    const {
      tebak,
      beli4D,
      depan3D,
      belakang3D,
      belakang2D,
      depan2D,
      tengah2D,
    } = inputs;
    const dataangka = [];

    if (tebak === 0 || tebak === "") {
      setIsDisabled(true);
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }
    if (
      beli4D.trim() === "" &&
      depan3D.trim() === "" &&
      belakang3D.trim() === "" &&
      belakang2D.trim() === "" &&
      depan2D.trim() === "" &&
      tengah2D.trim() === ""
    ) {
      setIsDisabled(true);
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }

    if (beli4D !== 0 && beli4D !== "") {
      dataangka.push(["4D-" + tebak, beli4D * multipleValue, "success"]);
    }

    if (depan3D !== 0 && depan3D !== "") {
      dataangka.push(["3D Depan-" + tebak, depan3D * multipleValue, "success"]);
    }

    if (belakang3D !== 0 && belakang3D !== "") {
      dataangka.push(["3D Belakang-" + tebak, belakang3D * multipleValue, "success"]);
    }

    if (depan2D !== 0 && depan2D !== "") {
      dataangka.push(["2D Depan-" + tebak, depan2D * multipleValue, "success"]);
    }

    if (tengah2D !== 0 && tengah2D !== "") {
      dataangka.push(["2D Tengah-" + tebak, tengah2D * multipleValue, "success"]);
    }

    if (belakang2D !== 0 && belakang2D !== "") {
      dataangka.push(["2D Belakang-" + tebak, belakang2D * multipleValue, "success"]);
    }

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "bbcampuran",
      betTogelAuth: "betTogelAuth",
    };
    makeAjax(url.TOGEL_API.processBBCampuran, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          response.code
            ? showMessage(props.t(response.code), "error", "error")
            : showMessage(props.t("guess_bet_wrong_place"), "error", "error");
          return;
        }
        showMessage("server error No data found", "error", "error");
        return;
      }
      const { asort4number, asort3number, asort2number, typebet } =
        response.data;
        console.log("asort4number", asort4number);
        
      setGuessData({ asort4number, asort3number, asort2number });
      setIsDataFetched(true);
      setIsDisabled(true);
      setOptionsEnabled({
        "2D Belakang": false,
        "2D Depan": false,
        "2D Tengah": false,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
      });
      setTypebet(typebet);
    });
  };

  const sortObjectByKeys = (obj) => {
    if (obj) {
      return Object.keys(obj)
        .sort()
        .map((key) => obj[key]);
    }
    return [];
  };
  // console.log("guessData.asort4number", guessData.asort4number);
  
  const sortedAsort4Number = guessData.asort4number;
  const sortedAsort3Number = guessData.asort3number;
  const sortedAsort2Number = guessData.asort2number;

  // const sortedAsort4NumberArray = Object.values(sortedAsort4Number);
  // const sortedAsort3NumberArray = Object.values(sortedAsort3Number);
  // const sortedAsort2NumberArray = Object.values(sortedAsort2Number);
  const sortedAsort4NumberArray = sortedAsort4Number;
  const sortedAsort3NumberArray = sortedAsort3Number;
  const sortedAsort2NumberArray = sortedAsort2Number;
  console.log("sortedAsort4NumberArray", sortedAsort4NumberArray);
  
  const calculateTotal = () => {
    let totalAmt = 0;
    let discountAmount = 0;
    const calculateRowTotal = (condition, array, discount) => {
      if (condition && array && array.length) {
        let newValue = (condition * 1000 * array.length) - (condition * 1000 * array.length * discount) / 100
        // totalAmt += newValue;
        const rowTotal = condition * 1000 * array.length;
        totalAmt += rowTotal;
        discountAmount += rowTotal * (discount / 100); // Apply the discount

      }
    };

    calculateRowTotal(
      inputs.beli4D,
      guessData.asort4number && guessData.asort4number, betDiscount.showDisc4d
    );
    calculateRowTotal(
      inputs.depan3D,
      guessData.asort3number && guessData.asort3number, betDiscount.showDisc3d
    );
    calculateRowTotal(
      inputs.belakang3D,
      guessData.asort3number && guessData.asort3number, betDiscount.showDisc3d
    );
    calculateRowTotal(
      inputs.depan2D,
      guessData.asort2number && guessData.asort2number, betDiscount.showDisc2d
    );
    calculateRowTotal(
      inputs.tengah2D,
      guessData.asort2number && guessData.asort2number, betDiscount.showDisc2d
    );
    calculateRowTotal(
      inputs.belakang2D,
      guessData.asort2number && guessData.asort2number, betDiscount.showDisc2d
    );
    const payAmount = totalAmt - discountAmount;
    setTotal(totalAmt);
    setDiscountAmount(discountAmount);
    setPayAmount(payAmount)
  };

  const handleCheckboxChange = (key, isChecked) => {
    setCheckedState((prevState) => ({
      ...prevState,
      [key]: isChecked,
    }));
  };

  const renderConditionalRows = () => {
    const rows = [];
    let index = 1;
    let temp = 0;

    const addRow = (condition, array, key) => {
      let multipleAmt = 0
      if (key == "beli4D") {
        multipleAmt = (condition * 1000) - (condition * 1000 * (game_sub_child_type == "DISCOUNT" ? betDiscount.showDisc4d : 0)) / 100
      }
      else if (key == "belakang3D" || key == "depan3D") {
        multipleAmt = (condition * 1000) - (condition * 1000 * (game_sub_child_type == "DISCOUNT" ? betDiscount.showDisc3d : 0)) / 100
      }
      else if (key == "belakang2D" || key == "depan2D" || key == "tengah2D") {
        multipleAmt = (condition * 1000) - (condition * 1000 * (game_sub_child_type == "DISCOUNT" ? betDiscount.showDisc2d : 0)) / 100
      }

      if (condition && array && array.length) {
        rows.push(
          <tr key={key}>
            <td>{index++}</td>
            <td style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="chk_bb"
                value={key}
                checked={checkedState[key] || false}
                onChange={(e) => handleCheckboxChange(key, e.target.checked)}
              />
              {array.length}
            </td>
            <td
              style={{
                overflowY: "auto",
                maxHeight: "130px",
                minWidth: "660px",
                display: "block",
                whiteSpace: "normal",
                fontFamily: "sans-serif",
              }}
              className="bet_probability_column"
            >
              {array.map((value) => Object.values(value).join("")).join(" : ")}{" "}
              {"(" + typebet[temp] + ")"}
            </td>
            <td style={{ textAlign: "right", width: 90, paddingRight: 20 }}>
              <div className="format-price-text">
                {`${formatPrice(multipleAmt)} X`} <br />{" "}
                {`${array.length}`} = <br />
                {`${formatPricewithdecimal(multipleAmt * array.length)}`}
              </div>
            </td>
          </tr>
        );
        temp++;
      }
    };

    addRow(inputs.beli4D, sortedAsort4NumberArray, "beli4D");
    addRow(inputs.depan3D, sortedAsort3NumberArray, "depan3D");
    addRow(inputs.belakang3D, sortedAsort3NumberArray, "belakang3D");
    addRow(inputs.depan2D, sortedAsort2NumberArray, "depan2D");
    addRow(inputs.tengah2D, sortedAsort2NumberArray, "tengah2D");
    addRow(inputs.belakang2D, sortedAsort2NumberArray, "belakang2D");

    return rows;
  };

  const submitProcess = (event) => {
    const checkedItems = Object.keys(checkedState).filter(
      (key) => checkedState[key]
    );
    if (!checkedItems.length) {
      setIsDisabled(true);
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }
    setShowConfirmationPopup(true);
  };

  const submitBBFS = (data) => {
    setShowConfirmationPopup(false);
    const checkedItems = Object.keys(checkedState).filter(
      (key) => checkedState[key]
    );
    const dataangka = [];
    const {
      tebak,
      beli4D,
      depan3D,
      belakang3D,
      belakang2D,
      depan2D,
      tengah2D,
    } = inputs;

    if (checkedItems.includes("beli4D") && beli4D) {
      dataangka.push([tebak + "##4D", beli4D * multipleValue, "success"]);
    }
    if (checkedItems.includes("depan3D") && depan3D) {
      dataangka.push([tebak + "##3D DEPAN", depan3D * multipleValue, "success"]);
    }
    if (checkedItems.includes("belakang3D") && belakang3D) {
      dataangka.push([tebak + "##3D BELAKANG", belakang3D * multipleValue, "success"]);
    }
    if (checkedItems.includes("belakang2D") && belakang2D) {
      dataangka.push([tebak + "##2D BELAKANG", belakang2D * multipleValue, "success"]);
    }
    if (checkedItems.includes("depan2D") && depan2D) {
      dataangka.push([tebak + "##2D DEPAN", depan2D * multipleValue, "success"]);
    }
    if (checkedItems.includes("tengah2D") && tengah2D) {
      dataangka.push([tebak + "##2D TENGAH", tengah2D * multipleValue, "success"]);
    }

    data = {
      gameId: gameId,
      dataangka: dataangka,
      dfp: betType,
      action: "process",
      gameType: "bbcampuran",
      allowPartner: "allowPartner",
      betTogelAuth: "betTogelAuth",
    };
    makeAjax(url.TOGEL_API.process4D3D2D, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong_place"));
          setShowErrorPopup(true);
          return;
        }
        showMessage(" ", "error", "error");
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
  };
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  return (
    <div className="quikbet_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="first_section">
            <label htmlFor="">{props.t("guess")}</label>
            <input
              type="text"
              maxlength="9"
              value={inputs.tebak}
              name="tebak"
              onBlur={handleTebakInputChange}
              onChange={handleTebakOnchange}
              inputMode="numeric"
              pattern="[0-9]*"
              disabled={isDisabled}
              autoComplete="off"
            // disabled = {}
            />
          </div>
          <div className="bbf_table">
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                4D
              </p>
              <input
                type="text"
                name="beli4D"
                displayname="4D"
                value={inputs.beli4D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["4D Belakang"]}
                className="bbf_inputs"
              />
            </div>
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                3D <br /> Belakang
              </p>
              <input
                type="text"
                name="belakang3D"
                displayname="3D belakang"
                value={inputs.belakang3D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["3D Belakang"]}
                className="bbf_inputs"
              />
            </div>
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                2D <br /> Belakang
              </p>
              <input
                type="text"
                name="belakang2D"
                displayname="2D belakang"
                value={inputs.belakang2D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["2D Belakang"]}
                className="bbf_inputs"
              />
            </div>
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                3D <br /> Depan{" "}
              </p>
              <input
                type="text"
                name="depan3D"
                displayname="3D depan"
                value={inputs.depan3D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["3D Depan"]}
                className="bbf_inputs"
              />
            </div>
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                2D <br /> Depan{" "}
              </p>
              <input
                type="text"
                name="depan2D"
                displayname="2D depan"
                value={inputs.depan2D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["2D Depan"]}

                className="bbf_inputs"
              />
            </div>
            <div className="bbf_table_item">
              <p>{props.t("buy")}</p>
              <p className="bbf_table_p2" style={{ textAlign: "center" }}>
                2D Tengah{" "}
              </p>
              <input
                type="text"
                name="tengah2D"
                displayname="2D tengah"
                value={inputs.tengah2D}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onKeyDown={handleKeyDown}
                inputMode="decimal"
                pattern="[0-9]*[.,]?[0-9]**"
                placeholder="Bet"
                // disabled={isDisabled}
                disabled={!optionsEnabled["2D Tengah"]}

                className="bbf_inputs"
              />
            </div>
          </div>
          <div className="btn_section">
            <ul className="button-list">
              <li>
                <button className="reset" onClick={handleReset}>
                  {props.t('reset')}
                </button>
              </li>
              <li>
                <button className="submit" onClick={getGuessList}>
                  {props.t('submit')}
                </button>
              </li>
            </ul>
          </div>
          {isDataFetched && (
            <div className="polaTarung_probability_container">
              <div className="probability_container">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>No.</th>
                      <th></th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("buy")}</th>
                    </tr>
                  </thead>
                  <tbody>{renderConditionalRows()}</tbody>
                </table>
              </div>
              {game_sub_child_type == "DISCOUNT" ?
                <div className="betdiskon_total">
                  <div className="d-flex flex-direction-column total">
                    <div className="data-submit">
                      {props.t("total_amount")}:
                      <span className="betdiskon_total_amount">
                        {formatPrice(total)}
                      </span>
                    </div>
                    <div className="data-discount">
                      {props.t("discount")}:
                      <span className="betdiskon_total_discount">
                        -{formatPricewithdecimal(discountAmount)}
                      </span>
                    </div>
                    <div className="total_pay">
                      {props.t("total")} {props.t("pay")}:
                      <span className="betdiskon_total_pay">
                        {formatPricewithdecimal(payAmount)}
                      </span>
                    </div>
                  </div>
                </div>
                :
                <div className="betdiskon_total">
                  <div className="d-flex flex-direction-column total"></div>
                  <div className="total_pay">
                    {props.t("total")} {props.t("pay")}:
                    <span className="betdiskon_total_pay">
                      {formatPricewithdecimal(total)}
                    </span>
                  </div>
                </div>
              }

              <div className="btn_section1">
                <ul className="button-list1">
                  <li>
                    <button className="submit" onClick={submitProcess}>
                      Submit
                    </button>
                  </li>
                </ul>
                {/* <div className="total_bayar_txt">
                  {props.t('total')} : <span>{formatPrice(total)}</span>
                </div> */}
              </div>
            </div>
          )}
          {showInfo && (
            <div className="Instruction_section">
              <p>{props.t("how_to_use_bbfs")}:</p>
              <p>{props.t("bbfs_quickbuy_description")}</p>
              <p>1. {props.t("bbfs_instruction_1")}</p>
              <p>2. {props.t("bbfs_instruction_2")}</p>
              <p>3. {props.t("bbfs_instruction_3")}</p>
              <p>4. {props.t("bbfs_instruction_4")}</p>
              <p>{props.t("bbfs_purchase_instruction_1")}</p>
              <p>{props.t("bbfs_purchase_instruction_2")}</p>
            </div>
          )}

          {
            /*---error popup --*/
            showErrorPopup && (
              <ErrorInnerPopup
                modalTitle={""}
                modalHeader={true}
                onCloseModal={() => setShowErrorPopup(false)}
              >
                <ErrorPopup
                  message={errMessage}
                  onClose={() => {
                    setShowErrorPopup(false);
                    setIsDisabled(false);
                  }}
                />
              </ErrorInnerPopup>
            )
          }

          {submitPopup && (
            <BbfsPopup onClose={closeSubmitPopup} submitResult={submitResult} />
          )}

          {showConfirmationPopup && (
            <ConfirmBetDeskonPopup
              onClose={hanldeConfirmationPopupClose}
              submitProcessOk={submitBBFS}
            />
          )}
          {showCancelledPopup && (
            <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
          )}
        </>
      )}


    </div>
  );
};

export default withTranslation()(BbfsBet);
